export default "/assets/images/chart-sm-03.svg?22b10ffede8a58dfe3af8efe98454448";